import { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import HomePage from './pages/HomePage'
import AuthPage from './pages/AuthPage'
import RegisterPage from './pages/RegisterPage'
import DashboardPage from './pages/DashboardPage'
import ShippingPage from './pages/ShippingPage'
import ReportPage from './pages/ReportPage'
import AdminLoginPage from './pages/AdminLoginPage'
import AdminDashboardPage from './pages/AdminDashboardPage'
import RequireAdmin from './components/RequireAdmin'

function App() {
  const location = useLocation()

  useEffect(() => {
    console.log('[App] Route changed:', {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      timestamp: new Date().toISOString()
    })
  }, [location])

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />

      {/* Legacy redirects — old public URLs now require admin auth */}
      <Route path="/shipping" element={<Navigate to="/admin/shipping" replace />} />
      <Route path="/report" element={<Navigate to="/admin/report" replace />} />

      {/* Admin portal */}
      <Route path="/admin" element={<RequireAdmin><AdminDashboardPage /></RequireAdmin>} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/register" element={<Navigate to="/admin/login" replace />} />
      <Route path="/admin/shipping" element={<RequireAdmin><ShippingPage /></RequireAdmin>} />
      <Route path="/admin/report" element={<RequireAdmin><ReportPage /></RequireAdmin>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
